export default defineNuxtRouteMiddleware(async (to) => {
  // You need to be logged in as an admin or editor to be able to see the styleguide
  if (to.matched[0].path.startsWith('/:prefix()/styleguide')) {
    const drupalUser = await useDrupalUser()
    if (!drupalUser.value.canAccessToolbar) {
      return abortNavigation()
    }
  }
})
